export default __webpack_public_path__ + "static/media/windpark--bockhorn_DJI_0281.747dd7e0.jpg";